import VocabularyCards from './VocabularyCards';

export default VocabularyCards;
